import React, { useState } from "react";
import { VscGrabber, VscClose } from "react-icons/vsc";
import { Link } from "react-router-dom";
import { logotext, socialprofils } from "helper/constants/content_option";
import Themetoggle from "components/ThemeToggle";

const Headermain = () => {
  const [isActive, setActive] = useState("false");

  const handleToggle = () => {
    setActive(!isActive);
    document.body.classList.toggle("ovhidden");
  };

  return (
    <>
      <header className="fixed-top site__header">
        <div className="d-flex align-items-center justify-content-between">
          <Link className="navbar-brand nav_ac" to="/">
            {logotext}
          </Link>
          <div className="d-flex align-items-center">
            <Themetoggle />
            <button className="menu__button  nav_ac" onClick={handleToggle}>
              {!isActive ? <VscClose /> : <VscGrabber />}
            </button>
          </div>
        </div>

        <div className={`site__navigation ${!isActive ? "menu__opend" : ""}`}>
          <div className="bg__menu h-100">
            <div className="menu__wrapper">
              <div className="menu__container p-3">
                <ul className="the_menu">
                  <li className="menu_item ">
                    <Link onClick={handleToggle} to="/" className="my-3">
                      Home
                    </Link>
                  </li>
                  <li className="menu_item">
                    <Link onClick={handleToggle} to="/about" className="my-3">
                      Persona
                    </Link>
                  </li>
                  <li className="menu_item">
                    <Link
                      onClick={handleToggle}
                      to="/academics"
                      className="my-3"
                    >
                      Academics
                    </Link>
                  </li>
                  <li className="menu_item">
                    <Link onClick={handleToggle} to="/work" className="my-3">
                      Career
                    </Link>
                  </li>
                  <li className="menu_item">
                    <Link
                      onClick={handleToggle}
                      to="/resources"
                      className="my-3"
                    >
                      Resources
                    </Link>
                  </li>
                  {window.innerWidth > 1024 && (
                    <li className="menu_item">
                      <Link
                        onClick={handleToggle}
                        to="/portfolio"
                        className="my-3"
                      >
                        Snaps
                      </Link>
                    </li>
                  )}
                  <li className="menu_item">
                    <Link onClick={handleToggle} to="/contact" className="my-3">
                      Connect
                    </Link>
                  </li>
                </ul>
              </div>
            </div>
          </div>
          <div className="menu_footer d-flex flex-column flex-md-row justify-content-between align-items-md-center position-absolute w-100 p-3">
            <div className="d-flex">
              {socialprofils.facebook && (
                <a href={socialprofils.facebook}>Facebook</a>
              )}
              {socialprofils.github && (
                <a href={socialprofils.github}>Github</a>
              )}
              {socialprofils.twitter && (
                <a href={socialprofils.twitter}>Twitter</a>
              )}
              {socialprofils.instagram && (
                <a href={socialprofils.instagram}>Instagram</a>
              )}
              {socialprofils.linkedin && (
                <a href={socialprofils.linkedin}>LinkedIn</a>
              )}
            </div>
            <p className="copyright m-0">©{logotext}</p>
          </div>
        </div>
      </header>
      <div className="br-top"></div>
      <div className="br-bottom"></div>
      <div className="br-left"></div>
      <div className="br-right"></div>
    </>
  );
};

export default Headermain;
